import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";

export default function PfsUpgradeGate() {
  return (
    <div className="max-w-2xl mx-auto py-12" data-testid="pfs-upgrade-gate">
      <div className="bg-white border border-slate-200 rounded-sm p-10 text-center shadow-sm">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-emerald-50 mb-4">
          <Lock className="w-7 h-7 text-emerald-600" />
        </div>
        <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit" }}>
          Personal Financial Statement
        </h1>
        <p className="text-sm font-mono uppercase tracking-widest text-emerald-600 mb-3">
          <Sparkles className="inline w-3.5 h-3.5 mr-1 -mt-0.5" />
          Pro &amp; Enterprise feature
        </p>
        <p className="text-slate-600 mb-8 max-w-md mx-auto">
          Build a banker-style PFS in minutes — multi-row schedules for real estate,
          autos, stocks, notes payable, and more. Snapshot history, password-protected
          lender share links, one-click underwriting packages, and a polished PDF lenders
          actually like reading.
        </p>
        <ul className="text-left max-w-md mx-auto space-y-2 mb-8 text-sm text-slate-700">
          {[
            "Auto-syncs your real-estate portfolio into the schedule",
            "Versioned snapshots with full audit trail",
            "Password-gated lender share links + view notifications",
            "One-click Lender Package: PFS + rent roll + binders + comps",
            "PDF export styled for SBA, Wells Fargo, Chase underwriting forms",
          ].map((item) => (
            <li key={item} className="flex items-start gap-2">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" />
              {item}
            </li>
          ))}
        </ul>
        <Link
          to="/dashboard/billing"
          className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-3 rounded-sm transition-colors"
          data-testid="pfs-upgrade-cta"
        >
          <Sparkles className="w-4 h-4" /> Upgrade to unlock
        </Link>
        <p className="text-xs text-slate-400 mt-4 italic">
          Already on Pro or Enterprise? Try refreshing — your plan may not have synced yet.
        </p>
      </div>
    </div>
  );
}
